<template>
  <nav class="flex h-full flex-col gap-2 overflow-y-auto px-3 py-3" :aria-label="t('admin.workspace_navigation.workspaces')">
    <template v-if="!cauldron">
      <h2 class="px-3 text-xs font-semibold text-theme-text-muted">{{ t('admin.workspace_navigation.workspaces') }}</h2>
      <SidebarMenuItem
        v-for="workspace in cauldrons"
        :key="workspace.id"
        :to="workspace.defaultRoute"
        :label="t(workspace.labelKey)"
        :icon="workspace.icon"
        size="sm"
        class="min-h-control-lg"
        data-cy="admin-workspace-link"
        @click="emit('navigate')"
      />
    </template>
    <template v-else>
      <section v-for="tool in cauldron.tools" :key="tool.id" data-cy="admin-tool-group">
        <h2 v-if="!tool.direct" class="mb-1 px-3 text-xs font-semibold text-theme-text-muted">{{ t(tool.labelKey) }}</h2>
        <template v-for="item in tool.items" :key="item.to || item.labelKey">
          <AppButton v-if="item.disabled" variant="ghost" tone="neutral" block justify="start" disabled class="min-h-[44px] text-left">
            <span>{{ t(item.labelKey) }}<span class="block text-xs font-normal">{{ t('admin.workspace_navigation.unavailable') }}</span></span>
          </AppButton>
          <SidebarMenuItem
            v-else
            :to="item.to"
            :label="t(item.labelKey)"
            :icon="item.icon"
            :active-match="item.activeMatch || 'prefix'"
            :class="isToolLocation(tool) ? 'bg-theme-brand/10' : ''"
            :aria-current="isToolLocation(tool) ? 'location' : undefined"
            size="sm"
            class="min-h-control-lg"
            @click="emit('navigate')"
          />
        </template>
      </section>
    </template>
  </nav>
</template>

<script setup>
  /* eslint-disable no-undef */
  import { ADMIN_CAULDRONS as cauldrons, getAdminToolByPath } from '@/admin/config/cauldrons';
  import SidebarMenuItem from '@/components/navigation/SidebarMenuItem.vue';
  import AppButton from '@/components/ui/buttons/AppButton.vue';
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';

  defineProps({ cauldron: { type: Object, default: null } });
  const emit = defineEmits(['navigate']);
  const { t } = useI18n();
  const route = useRoute();
  const activeToolId = computed(() => getAdminToolByPath(route?.path)?.tool.id);
  // A single-item direct tool stands for its whole route family (e.g. /newsroom/read under Artikeloverzicht);
  // with several items each row owns its own active state, else every sibling lights up.
  const isToolLocation = (tool) => tool.direct && tool.items.length === 1 && activeToolId.value === tool.id;
</script>
